import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createVNode as _createVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "field is-align-self-flex-start mt-2"
}
const _hoisted_2 = { class: "control" }
const _hoisted_3 = {
  key: 1,
  class: "is-flex is-flex-direction-column is-align-items-center mt-6"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "icon has-text-grey-lighter" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-skull-crossbones fa-beat icone-alerta" })
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h3", { class: "mt-4" }, "Não existem licenças para listar", -1)
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = {
  key: 2,
  class: "table is-hoverable"
}
const _hoisted_8 = {
  key: 0,
  class: "icon has-text-grey-light"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-chevron-down" }, null, -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = {
  key: 1,
  class: "icon has-text-grey-light"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-chevron-up" }, null, -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = {
  key: 0,
  class: "icon has-text-grey-light"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-chevron-down" }, null, -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = {
  key: 1,
  class: "icon has-text-grey-light"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-chevron-up" }, null, -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = {
  key: 0,
  class: "icon has-text-grey-light"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-chevron-down" }, null, -1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = {
  key: 1,
  class: "icon has-text-grey-light"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-chevron-up" }, null, -1)
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = {
  key: 0,
  class: "icon has-text-grey-light"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-chevron-down" }, null, -1)
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = {
  key: 1,
  class: "icon has-text-grey-light"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-chevron-up" }, null, -1)
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = {
  key: 0,
  class: "icon has-text-grey-light"
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-chevron-down" }, null, -1)
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = {
  key: 1,
  class: "icon has-text-grey-light"
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-chevron-up" }, null, -1)
const _hoisted_37 = [
  _hoisted_36
]
const _hoisted_38 = {
  key: 0,
  class: "icon has-text-grey-light"
}
const _hoisted_39 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-chevron-down" }, null, -1)
const _hoisted_40 = [
  _hoisted_39
]
const _hoisted_41 = {
  key: 1,
  class: "icon has-text-grey-light"
}
const _hoisted_42 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-chevron-up" }, null, -1)
const _hoisted_43 = [
  _hoisted_42
]
const _hoisted_44 = {
  key: 0,
  class: "icon has-text-grey-light"
}
const _hoisted_45 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-chevron-down" }, null, -1)
const _hoisted_46 = [
  _hoisted_45
]
const _hoisted_47 = {
  key: 1,
  class: "icon has-text-grey-light"
}
const _hoisted_48 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-chevron-up" }, null, -1)
const _hoisted_49 = [
  _hoisted_48
]
const _hoisted_50 = ["onClick"]
const _hoisted_51 = { width: "30%" }
const _hoisted_52 = { width: "10%" }
const _hoisted_53 = { width: "10%" }
const _hoisted_54 = { width: "10%" }
const _hoisted_55 = { width: "10%" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-circle" }, null, -1)
const _hoisted_57 = [
  _hoisted_56
]
const _hoisted_58 = { width: "15%" }
const _hoisted_59 = { width: "15%" }
const _hoisted_60 = { class: "tabs is-toggle is-toggle-rounded is-centered is-small" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("a", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "icon is-small" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa-regular fa-eye" })
  ]),
  /*#__PURE__*/_createElementVNode("span", null, "Visão Atual")
], -1)
const _hoisted_62 = [
  _hoisted_61
]
const _hoisted_63 = /*#__PURE__*/_createElementVNode("a", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "icon is-small" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-chart-simple" })
  ]),
  /*#__PURE__*/_createElementVNode("span", null, "Histórico")
], -1)
const _hoisted_64 = [
  _hoisted_63
]
const _hoisted_65 = { key: 1 }

import ILicenca from '@/interfaces/ILicenca';
  import { Ref, onMounted, ref } from 'vue';
  import ModalCard from './ModalCard.vue';
  import PaginatorComp from './PaginatorComp.vue';

  import DetalheLicenca from './DetalheLicenca.vue';
  import HistoricoLicenca from './HistoricoLicenca.vue';

  interface ITipoOrdenacao {
    empresa: number;
    aplicacoes: number;
    verticais: number;
    contextoExecucao: number;
    revogado: number;
    motorConcorrente: number;
    genConcorrente: number;
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'TabelaLicencas',
  props: {
    licencas: {}
  },
  setup(__props: any) {

  const props = __props;

  const filtro = ref('');
  const licencaSelecionada: Ref<ILicenca | null> = ref(null);
  const ultimoObjeto: Ref<any> = ref({
    id: '',
    totalVertical: 0,
    totalContexto: 0,
    totalVariavel: 0,
  });
  const licencasFiltradasEOrdenadas: Ref<ILicenca[]> = ref([]);
  const licencasPaginadas: Ref<[]> = ref([]);
  const tipoOrdenacao: Ref<ITipoOrdenacao> = ref({
    empresa: 0,
    aplicacoes: 0,
    verticais: 0,
    contextoExecucao: 0,
    revogado: 0,
    motorConcorrente: 0,
    genConcorrente: 0,
  });
  const modal = ref<InstanceType<typeof ModalCard> | null>(null);
  const abaAtiva: Ref<'atual' | 'historico'> = ref('atual');

  onMounted(() => {
    licencasFiltradasEOrdenadas.value = [...props.licencas];
  });

  function abrirDetalhes(licenca: ILicenca) {
    licencaSelecionada.value = licenca;
    const ultimo: any = Object.values(licencaSelecionada.value.objetos).at(-1);
    if (ultimo) {
      let totalContexto = ultimo.totalContexto
        ? Object.values(ultimo.totalContexto).reduce(
            (accumulator: number, value: any) => accumulator + value,
            0
          )
        : 0;
      console.log(Object.entries(licencaSelecionada.value.objetos));
      ultimoObjeto.value = {
        id: Object.keys(licencaSelecionada.value.objetos).at(-1),
        totalVertical: ultimo.totalVertical ? ultimo.totalVertical : 0,
        totalContexto,
      };
    } else {
      ultimoObjeto.value = {
        id: '',
        totalVertical: 0,
        totalContexto: 0,
        totalVariavel: 0,
      };
    }
    modal.value?.reveal();
  }

  function ordenar(
    tipo:
      | 'empresa'
      | 'verticais'
      | 'aplicacoes'
      | 'contextoExecucao'
      | 'revogado'
      | 'genConcorrente'
      | 'motorConcorrente'
  ) {
    if (tipoOrdenacao.value[tipo] === 2) {
      tipoOrdenacao.value[tipo] = 0;
    } else {
      tipoOrdenacao.value[tipo]++;
    }

    switch (tipoOrdenacao.value[tipo]) {
      case 0:
        licencasFiltradasEOrdenadas.value = [...props.licencas];
        break;
      case 1:
        licencasFiltradasEOrdenadas.value =
          licencasFiltradasEOrdenadas.value.sort((a: ILicenca, b: ILicenca) => {
            if (tipo === 'empresa') {
              return a.empresa.toLowerCase() > b.empresa.toLocaleLowerCase()
                ? 1
                : -1;
            } else {
              return a[tipo] > b[tipo] ? -1 : 1;
            }
          });
        break;
      case 2:
        licencasFiltradasEOrdenadas.value =
          licencasFiltradasEOrdenadas.value.sort((a: ILicenca, b: ILicenca) => {
            if (tipo === 'empresa') {
              return a.empresa.toLocaleLowerCase() <
                b.empresa.toLocaleLowerCase()
                ? 1
                : -1;
            } else {
              return a[tipo] < b[tipo] ? -1 : 1;
            }
          });
        break;
      default:
        break;
    }

    Object.keys(tipoOrdenacao.value).forEach(key => {
      if (key !== tipo) {
        tipoOrdenacao.value[key as keyof ITipoOrdenacao] = 0;
      }
    });
  }
  function filtrar() {
    tipoOrdenacao.value = {
      empresa: 0,
      aplicacoes: 0,
      verticais: 0,
      contextoExecucao: 0,
      revogado: 0,
      motorConcorrente: 0,
      genConcorrente: 0,
    };
    if (!filtro.value) {
      licencasFiltradasEOrdenadas.value = [...props.licencas];
    }
    licencasFiltradasEOrdenadas.value = props.licencas?.filter(
      (licenca: ILicenca) =>
        licenca.empresa.toUpperCase().includes(filtro.value.toUpperCase())
    );
  }

  function paginou(listaPaginada: []) {
    licencasPaginadas.value = listaPaginada;
  }

  function mudaAba(aba: 'atual' | 'historico') {
    abaAtiva.value = aba;
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.licencas?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _withDirectives(_createElementVNode("input", {
              class: "input",
              type: "text",
              placeholder: "Filtrar por empresa",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filtro).value = $event)),
              onKeyup: filtrar
            }, null, 544), [
              [_vModelText, filtro.value]
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.licencas?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_6))
      : _createCommentVNode("", true),
    (_ctx.licencas?.length)
      ? (_openBlock(), _createElementBlock("table", _hoisted_7, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (ordenar('empresa'))),
                title: "clique para ordenar"
              }, [
                _createTextVNode(" Empresa "),
                (tipoOrdenacao.value.empresa === 1)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, _hoisted_10))
                  : _createCommentVNode("", true),
                (tipoOrdenacao.value.empresa === 2)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_11, _hoisted_13))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("th", {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (ordenar('verticais')))
              }, [
                _createTextVNode(" Verticais "),
                (tipoOrdenacao.value.verticais === 1)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_14, _hoisted_16))
                  : _createCommentVNode("", true),
                (tipoOrdenacao.value.verticais === 2)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_17, _hoisted_19))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("th", {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (ordenar('aplicacoes')))
              }, [
                _createTextVNode(" Aplicações "),
                (tipoOrdenacao.value.aplicacoes === 1)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_20, _hoisted_22))
                  : _createCommentVNode("", true),
                (tipoOrdenacao.value.aplicacoes === 2)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_23, _hoisted_25))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("th", {
                onClick: _cache[4] || (_cache[4] = ($event: any) => (ordenar('contextoExecucao')))
              }, [
                _createTextVNode(" Contextos de Execução "),
                (tipoOrdenacao.value.contextoExecucao === 1)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_26, _hoisted_28))
                  : _createCommentVNode("", true),
                (tipoOrdenacao.value.contextoExecucao === 2)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_29, _hoisted_31))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("th", {
                onClick: _cache[5] || (_cache[5] = ($event: any) => (ordenar('revogado')))
              }, [
                _createTextVNode(" Status "),
                (tipoOrdenacao.value.revogado === 1)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_32, _hoisted_34))
                  : _createCommentVNode("", true),
                (tipoOrdenacao.value.revogado === 2)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_35, _hoisted_37))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("th", {
                onClick: _cache[6] || (_cache[6] = ($event: any) => (ordenar('motorConcorrente')))
              }, [
                _createTextVNode(" Motores Concorrentes "),
                (tipoOrdenacao.value.motorConcorrente === 1)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_38, _hoisted_40))
                  : _createCommentVNode("", true),
                (tipoOrdenacao.value.motorConcorrente === 2)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_41, _hoisted_43))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("th", {
                onClick: _cache[7] || (_cache[7] = ($event: any) => (ordenar('genConcorrente')))
              }, [
                _createTextVNode(" Binários Concorrentes "),
                (tipoOrdenacao.value.genConcorrente === 1)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_44, _hoisted_46))
                  : _createCommentVNode("", true),
                (tipoOrdenacao.value.genConcorrente === 2)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_47, _hoisted_49))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((licencasPaginadas.value as ILicenca[]), (licenca) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: licenca.uuid,
                onClick: ($event: any) => (abrirDetalhes(licenca)),
                title: "Clique para ver os detalhes da licença"
              }, [
                _createElementVNode("td", _hoisted_51, _toDisplayString(licenca.empresa), 1),
                _createElementVNode("td", _hoisted_52, _toDisplayString(licenca.verticais), 1),
                _createElementVNode("td", _hoisted_53, _toDisplayString(licenca.aplicacoes), 1),
                _createElementVNode("td", _hoisted_54, _toDisplayString(licenca.contextoExecucao), 1),
                _createElementVNode("td", _hoisted_55, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["icon", {
              'has-text-success': licenca.revogado === 'N',
              'has-text-danger': licenca.revogado === 'S',
            }])
                  }, _hoisted_57, 2),
                  _createTextVNode(" " + _toDisplayString(licenca.revogado === 'N' ? 'Online' : 'Offline'), 1)
                ]),
                _createElementVNode("td", _hoisted_58, _toDisplayString(licenca.motorConcorrente), 1),
                _createElementVNode("td", _hoisted_59, _toDisplayString(licenca.genConcorrente), 1)
              ], 8, _hoisted_50))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(PaginatorComp, {
      lista: (licencasFiltradasEOrdenadas.value as []),
      onPaginate: paginou
    }, null, 8, ["lista"]),
    _createVNode(ModalCard, {
      ref_key: "modal",
      ref: modal,
      onOnCancel: _cache[10] || (_cache[10] = ($event: any) => (mudaAba('atual')))
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(licencaSelecionada.value?.empresa), 1)
      ]),
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_60, [
          _createElementVNode("ul", null, [
            _createElementVNode("li", {
              class: _normalizeClass({ 'is-active': abaAtiva.value === 'atual' }),
              onClick: _cache[8] || (_cache[8] = ($event: any) => (mudaAba('atual')))
            }, _hoisted_62, 2),
            _createElementVNode("li", {
              class: _normalizeClass({ 'is-active': abaAtiva.value === 'historico' }),
              onClick: _cache[9] || (_cache[9] = ($event: any) => (mudaAba('historico')))
            }, _hoisted_64, 2)
          ])
        ]),
        (abaAtiva.value === 'atual')
          ? (_openBlock(), _createBlock(DetalheLicenca, {
              key: 0,
              licenca: licencaSelecionada.value,
              "ultimo-objeto": ultimoObjeto.value
            }, null, 8, ["licenca", "ultimo-objeto"]))
          : (_openBlock(), _createElementBlock("div", _hoisted_65, [
              _createVNode(HistoricoLicenca, { "licenca-selecionada": licencaSelecionada.value }, null, 8, ["licenca-selecionada"])
            ]))
      ]),
      _: 1
    }, 512)
  ], 64))
}
}

})